"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDnd = require("react-dnd");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var source = {
  beginDrag: function beginDrag(props, monitor, component) {
    component.dragId = setInterval(function () {
      var clientOffset = monitor.getClientOffset();
      props.handleMouseX(clientOffset.x);
    }, 20);
    return {};
  },
  endDrag: function endDrag(props, monitor, component) {
    clearInterval(component.dragId);
    props.onDrop();
  }
};
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}
var Arrow = /*#__PURE__*/function (_React$Component) {
  _inherits(Arrow, _React$Component);
  function Arrow() {
    _classCallCheck(this, Arrow);
    return _callSuper(this, Arrow, arguments);
  }
  _createClass(Arrow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;
      var img = new Image();
      img.onload = function () {
        return _this.props.connectDragPreview(img);
      };
      img.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        connectDragSource = _this$props.connectDragSource,
        leftPosition = _this$props.leftPosition,
        isDragging = _this$props.isDragging,
        currentValue = _this$props.currentValue,
        settings = _this$props.settings,
        style = _this$props.style;
      return connectDragSource( /*#__PURE__*/_react["default"].createElement("div", {
        className: style.slider,
        style: {
          left: leftPosition + '%'
        }
      }, isDragging && settings.showNumberWhenDragging && /*#__PURE__*/_react["default"].createElement("div", {
        className: style.sliderNumber
      }, currentValue)));
    }
  }]);
  return Arrow;
}(_react["default"].Component);
_defineProperty(Arrow, "propTypes", {
  connectDragSource: _propTypes["default"].func.isRequired,
  connectDragPreview: _propTypes["default"].func.isRequired,
  isDragging: _propTypes["default"].bool.isRequired,
  leftPosition: _propTypes["default"].number,
  handleMouseX: _propTypes["default"].func,
  onDrop: _propTypes["default"].func,
  constant: _propTypes["default"].string,
  currentValue: _propTypes["default"].number,
  settings: _propTypes["default"].object,
  style: _propTypes["default"].object
});
var _default = exports["default"] = (0, _reactDnd.DragSource)('SLIDER123', source, collect)(Arrow);